export default {
  setSortedPipefishUsers ({commit}, users) {
    users.sort((a,b) => {
      var nameA = a.GivenName.toUpperCase()
      var nameB = b.GivenName.toUpperCase()
      if(nameA < nameB) {
        return -1
      }
      if(nameA > nameB) {
        return 1
      }
      return 0
    })
    commit('setPipefishUsers', users)
  }
}